'use strict';

const {filter, map} = require('lodash/collection'),
    Constants = require('constants/AppConstants'),
    Security = require('services/Security').auth,
    ContentUtils = require('utils/ContentUtils'),
    RestUtils = require('utils/RestUtils'),
    apiAppUrl = process.env.URL_API,
    KEY_PERMISSIONS = 'cache_permissions',
    KEY_USER_PERMISSIONS = 'cache_user_permissions',
    KEY_USER_PERMISSIONS_NAME = 'cache_user_permissions_name',
    get = require('lodash/object').get;


const UserPermissionStore = {

    getPermissions() {
        return ContentUtils.getSession(KEY_PERMISSIONS) || [];
    },

    getUserPermissions() {
        return ContentUtils.getSession(KEY_USER_PERMISSIONS) || [];
    },

    getUserPermissionNames() {
        return ContentUtils.getSession(KEY_USER_PERMISSIONS_NAME) || [];
    },

    setUserPermissions(userPermissions) {
        ContentUtils.saveSession(KEY_USER_PERMISSIONS, userPermissions);
        ContentUtils.saveSession(KEY_USER_PERMISSIONS_NAME, map(userPermissions, permission => get(permission, 'name')));
    },

    setPermissions(permissions) {
        ContentUtils.saveSession(KEY_PERMISSIONS, permissions);
    },


    /**
     * Filter the modules which are allowed by my user.
     * @param modules
     * @returns {*}
     */
    filterModules(modules) {
        const modulesNonEmpty = filter(modules, module => module);//remove undefined modules
        return filter(modulesNonEmpty, module => {
            const permissionName = get(module, 'permission');
            const isMatcherPermission = this.getUserPermissionNames().indexOf(permissionName) > -1;
            const isModulePublic = module.permission === undefined;
            return isMatcherPermission || isModulePublic;
        });
    },

    shouldShow(moduleName, permissionTarget) {
        const permissions = this.getUserPermissionNames();
        const permissionTargetName = `${moduleName}_${permissionTarget}`;
        return permissions.some(permission => permission === permissionTargetName);
    },

    getUsersAccess(onSuccess, onFailure, tokenString, applicantId) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.response));
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText));
            });
        });

        ajax.open('GET', apiAppUrl + '/api/users/permissions', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, tokenString || Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
        ajax.send();
    }

};

module.exports = UserPermissionStore;



/** WEBPACK FOOTER **
 ** ./src/stores/UserPermissionStore.js
 **/